{
    "Device_Filter_SectionHeader": "Filtrage du type d'appareil",
    "Device_Filter_Dropdown_Label": "Type d'appareil",
    "NAME": "ReportsFilterDeviceFilter"
}